const termsData = {
    title: "Terms and Conditions",
    updatedDate: "April 1, 2025",
    introduction: [
        "MINDSCLIK through its platform MPERITO provides ability for its customers to launch their branded ecommerce application on web and mobile. As part of the solution few of its customers (businesses) can leverage MINDSCLIK payment gateway to collect money on the purchases made end customer.",
        "The following Terms and Conditions is applicable to the Customers or Businesses that are leveraging the MPERITO platform along with its payment gateway:"
    ],
    sections: [
        {
            title: "Accountability for Brands Leveraging MINDSCLIK Payment Account",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Brands utilizing the MINDSCLIK payment account for transactions are solely responsible for the accuracy of their product listings, order fulfilment, and customer service.",
                        "MINDSCLIK and MPERITO are not liable for any disputes, financial losses, or damages arising from transactions conducted by brands through the MINDSCLIK payment account."
                    ]
                },

            ]
        },
        {
            title: "Intellectual Property Rights",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Brands retain ownership of their intellectual property rights related to product listings, branding, and content uploaded to the MPERITO platform.",
                        "By using the platform, brands grant MINDSCLIK and MPERITO a non-exclusive license to use, reproduce, and display their intellectual property for the purpose of operating and promoting the platform."
                    ]
                },

            ]
        },
        {
            title: "Data Privacy and Security",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "MINDSCLIK and MPERITO are committed to protecting the privacy and security of user data in accordance with applicable laws and regulations.",
                        "Brands agree not to misuse or disclose any confidential information obtained through the platform, including customer data and proprietary information."
                    ]
                },

            ]
        },
        {
            title: "Indemnification",
            subtitle: "",
            content: [
                {
                    type: "bullet",
                    items: [
                        "Brands agree to indemnify and hold MINDSCLIK and MPERITO harmless from any claims, losses, liabilities, damages, or expenses (including legal fees) arising from their use of the platform or any violation of these terms and conditions.",
                    ]
                },

            ]
        },
        {
            title: "Governing Law and Dispute Resolution",
            subtitle: "",
            content: [
                {
                    type: "text",
                    items: [
                        "1.  Governing Law"
                    ]
                },
                {
                    type: "bullet",
                    items: [
                        "These terms and conditions shall be governed by and construed in accordance with the laws of the Republic of India."
                    ]
                },
                {
                    type: "text",
                    items: [
                        "2.  Arbitration"
                    ]
                },
                {
                    type: "bullet",
                    items: [
                        "Any disputes, controversies, or claims arising out of or relating to these terms and conditions, including any disputes regarding its existence, validity, or termination, shall be referred to and finally resolved by arbitration in accordance with the provisions of the Arbitration and Conciliation Act, 1996.",
                        "The arbitration proceedings shall be conducted by a sole arbitrator appointed by mutual agreement between the parties. If the parties fail to agree on the appointment of an arbitrator within 30 days of a written demand for arbitration, the arbitrator shall be appointed by the [Appointing Authority], in accordance with the Arbitration and Conciliation Act, 1996.",
                        "The arbitration proceedings shall be conducted in the English language and shall be held in Benguluru, India.",
                        "The decision of the arbitrator shall be final and binding on the parties, and judgment upon the award rendered by the arbitrator may be entered in any court having jurisdiction thereof.",
                        "The costs of arbitration, including the fees and expenses of the arbitrator, shall be borne equally by the parties, unless the arbitrator directs otherwise in the award."
                    ]
                },
                {
                    type: "text",
                    items: [
                        "3.  Applicable Law"
                    ]
                },
                {
                    type: "bullet",
                    items: [
                        "The arbitration proceedings and the enforcement of any arbitral award shall be governed by the laws of the Republic of India."
                    ]
                },
                {
                    type: "text",
                    items: [
                        "4.  Jurisdiction"
                    ]
                },
                {
                    type: "bullet",
                    items: [
                        "The courts in Benguluru, India, shall have exclusive jurisdiction over any proceedings arising out of or in connection with the arbitration or enforcement of any arbitral award."
                    ]
                },

            ]
        },
        {
            title: "Changes to this Terms and Conditions",
            subtitle: "",
            content: [
                {
                    type: "text",
                    items: [
                        "We may update OurTerms and Conditions from time to time. We will notify You of any changes by posting the new Terms and Conditions on this page.",
                        'We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Terms and Conditions.',
                        'You are advised to review this Terms and Conditions periodically for any changes. Changes to this Terms and Conditions are effective when they are posted on this page.'
                    ]
                },

            ]
        },
        {
            title: "Contact Us",
            subtitle: "",
            content: [
                {
                    type: "text",
                    items: [
                        "If you have any questions about this Terms and Conditions, You can contact us:",
                    ]
                },
                {
                    type: "bullet",
                    items: [
                        "By email: support@mindsclik.com",
                    ]
                },

            ]
        },
    ]
};

export default termsData;

// type = { title | text | bullet | numbered }